import { useRef } from "react";
import { motion, useSpring, useScroll, useTransform } from "framer-motion";
import { EASE } from "../../lib/scroll";

export const Reveal = ({ children, delay = 0, y = 40, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8% 0px" }}
    transition={{ duration: 1, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const SplitReveal = ({ text, className, wordClass = "", delay = 0 }) => (
  <motion.span
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-10% 0px" }}
    transition={{ staggerChildren: 0.05, delayChildren: delay }}
  >
    {text.split(" ").map((w, i) => (
      <span key={`${w}-${i}`} className="inline-block overflow-hidden align-bottom pb-[0.08em] mr-[0.22em]">
        <motion.span
          className={`inline-block ${wordClass}`}
          variants={{ hidden: { y: "110%" }, show: { y: "0%", transition: { duration: 0.9, ease: EASE } } }}
        >
          {w}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const Tilt = ({ children, className, max = 7, ...rest }) => {
  const ref = useRef(null);
  const rx = useSpring(0, { stiffness: 140, damping: 16 });
  const ry = useSpring(0, { stiffness: 140, damping: 16 });
  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    ry.set(((e.clientX - r.left) / r.width - 0.5) * max * 2);
    rx.set(-((e.clientY - r.top) / r.height - 0.5) * max * 2);
  };
  const reset = () => { rx.set(0); ry.set(0); };
  return (
    <motion.div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={reset}
      style={{ rotateX: rx, rotateY: ry, transformPerspective: 1200, transformStyle: "preserve-3d" }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

const ScrubWord = ({ word, progress, range }) => {
  const opacity = useTransform(progress, range, [0.12, 1]);
  return <motion.span style={{ opacity }} className="mr-[0.25em] inline-block">{word}</motion.span>;
};

export const ScrubText = ({ text, className }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.45"] });
  const words = text.split(" ");
  return (
    <p ref={ref} className={`relative ${className}`}>
      {words.map((w, i) => (
        <ScrubWord key={`${w}-${i}`} word={w} progress={scrollYProgress} range={[i / words.length, (i + 1) / words.length]} />
      ))}
    </p>
  );
};
